import LandingPage from './pages/LandingPage';
import './App.css';

function App() {
  return (
    <div>
      <LandingPage />
    </div>
  );
}

export default App;
